export default __webpack_public_path__ + "static/media/033-beach volleyball.a1fe14e6.svg";